import { CommonModule, DatePipe } from "@angular/common";
import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  Output,
  ViewChild,
} from "@angular/core";
import { FormGroup, ReactiveFormsModule } from "@angular/forms";
import { ShippingMethod } from "../../../../core/models/shared/shippingMethod";
import { OrderLineItemDetailService } from "../../../../core/services/order-line-item-detail.service";
import { SelectChangeEvent, SelectModule } from "primeng/select";
import { DatePickerModule } from "primeng/datepicker";

import { ButtonModule } from "primeng/button";
import { CardModule } from "primeng/card";
import { InputTextModule } from "primeng/inputtext";
import { ToggleSwitchModule } from "primeng/toggleswitch";
import {
  computeMinDate,
  parseMMDDYYYY,
} from "../../../../core/utilities/mindate-function";

@Component({
  selector: "jni-line-item-details",
  templateUrl: "./line-item-details.component.html",
  styleUrls: ["./line-item-details.component.scss"],
  providers: [DatePipe],
  imports: [
    CommonModule,
    SelectModule,
    ReactiveFormsModule,
    DatePickerModule,
    ButtonModule,
    CardModule,
    InputTextModule,
    ToggleSwitchModule,
  ],
})
export class LineItemDetailsComponent {
  @Input() parent!: FormGroup;
  @Input() shippingProductsList: ShippingMethod[] = [];
  @Input() customerId = "";
  @Input() headerShipDate = "";
  @Input() headerInhandDate = "";
  @Input() formErrors!: Record<string, string>;
  @Output() validationErrorEvent = new EventEmitter();

  @ViewChild("nameInput") inputNameRef!: ElementRef;
  @ViewChild("nameInput1") inputNameRef1!: ElementRef;

  shipDate = new Date().toISOString();
  inHandDate = new Date().toISOString();
  shipdate = "";
  shipDateCurrentdate!: Date;
  inHandDateCurrentdate!: Date;

  constructor(
    private _orderLineItemDetailService: OrderLineItemDetailService,
    public datepipe: DatePipe
  ) {}

  setMinDate() {
    const shipDateVal = parseMMDDYYYY(
      this.parent.get(["detail", "shipDate"])?.value
    );
    if (shipDateVal) {
      this.shipDateCurrentdate = computeMinDate(shipDateVal);
    } else {
      this.shipDateCurrentdate = computeMinDate();
    }
  }

  onShipDateSelection(event: Date) {
    //this.shipDate = event;
    const date = new Date(event);
    this.shipDate = this.datepipe.transform(date, "MM/dd/yyyy") ?? "";
    if (this.shipDate) {
      this.inHandDateCurrentdate = computeMinDate(this.shipDate, false);
    } else {
      this.inHandDateCurrentdate = computeMinDate();
    }
    this.parent.patchValue({
      detail: {
        shipDate: this.shipDate,
      },
    });
  }

  onInHandDateSelection(event: Date) {
    //this.inHandDate = event;
    const date = new Date(event);
    this.inHandDate = this.datepipe.transform(date, "MM/dd/yyyy") ?? "";
    this.parent.patchValue({
      detail: {
        inHandDate: this.inHandDate,
      },
    });
  }

  clearInHandDateAndShipDate() {
    this.parent.patchValue({
      detail: {
        inHandDate: "",
        shipDate: "",
      },
    });

    // (<HTMLInputElement>document.getElementById('shipdate')).value = '';
    // this.inputNameRef.nativeElement.onblur();
    // (<HTMLInputElement>document.getElementById('inhanddate')).value = '';
    // this.inputNameRef1.nativeElement.onblur();
  }

  onShippingMethodSelect(event: SelectChangeEvent) {
    const shippingMethodCode = event.value;
    const index = this.shippingProductsList.findIndex(
      x => x.modeCodeD365 == shippingMethodCode
    );

    if (index > -1) {
      const selectedShippingMethod = this.shippingProductsList[index];
      if (
        selectedShippingMethod.useFreightAccountD365?.toLowerCase() == "yes"
      ) {
        this.parent.patchValue({
          detail: {
            accountNumberD365: selectedShippingMethod.jniFreightAcctNumD365,
          },
        });
      } else {
        this._orderLineItemDetailService
          .getClientFreightAccountNumber(this.customerId)
          .subscribe({
            next: res => {
              if (res.data) {
                this.parent.patchValue({
                  detail: {
                    accountNumberD365: res.data,
                  },
                });
              } else {
                this.parent.patchValue({
                  detail: {
                    accountNumberD365: "",
                  },
                });
              }
            },
            error: () => {
              this.parent.patchValue({
                detail: {
                  accountNumberD365: "",
                },
              });
            },
          });
      }
    }
  }

  applyAccountLengthValidation(event: FocusEvent) {
    const target = event.target as HTMLInputElement;
    if (target.value) {
      this.parent.patchValue({
        detail: {
          accountNumberD365: target.value.substring(0, 40),
        },
      });
    }
  }

  logValidationErrors() {
    this.validationErrorEvent.emit();
  }

  /**
   * Returns true when the currently selected shipping method is a
   * Nadel freight account (e.g. FedEx / UPS Nadel Account). In that case
   * the supplier account number must be auto-populated and non-editable.
   */
  get isNadelFreightAccount(): boolean {
    const shippingMethodCode = this.parent?.get([
      "detail",
      "shippingMethod",
    ])?.value;
    if (!shippingMethodCode || !this.shippingProductsList?.length) {
      return false;
    }
    const method = this.shippingProductsList.find(
      x => x.modeCodeD365 === shippingMethodCode
    );

    if (method?.useFreightAccountD365?.toLowerCase() !== "yes") {
      return false;
    }

    // Client requirement: only hide/lock the account number when the
    // shipping method is UPS or FedEx (Nadel freight accounts).
    const description = method?.modeDescriptionD365?.toLowerCase() ?? "";
    return description.includes("ups") || description.includes("fedex");
  }

  onClearShippingMethodSelection() {
    this.parent.patchValue({
      detail: {
        accountNumberD365: "",
      },
    });
  }
}
